const updateHandler = (items, updateId, updateValues, updateFlag, noMerge) =>
	items.map(item => {
		if (item.id !== updateId) return item;
		if (noMerge) return { ...updateValues, updating: updateFlag };
		return { ...item, ...updateValues, updating: updateFlag };
	});

export default updateHandler;
